import { useCallback } from "react";
import { useLocalStorage } from "react-use";

/**
 * Tracks in local storage whether a user has viewed a piece of content.
 */
export function useHasViewed(key: string | string[]) {
  const viewKey = `Bingo: HasViewed: ${asArray(key).join("/")}`;
  const [hasViewed, setHasViewed] = useLocalStorage(viewKey, false);

  const setViewed = useCallback(() => setHasViewed(true), [setHasViewed]);

  return [Boolean(hasViewed), setViewed] as const;
}

function asArray(key: string | string[]) {
  return Array.isArray(key) ? key : [key];
}
